import React from 'react'

export default () => (
    <div>
    <p><strong>REGULAMIN PORTALU INTERNETOWEGO</strong></p>
  <p><strong>kontenerowy.pl, e-containers.eu, econtainers.ru, e-containers.de, e-containers.pl, 4containers.eu,
          4containers.ru, 4containers.pl, 4containers.de</strong></p>
  <p>Serwisy internetowe działający pod ww. adresami prowadzone są przez RR Media Sp. z o.o. <br />z siedzibą w Gdyni, ul.
      Janka Wiśniewskiego 31 lok. 328, zarejestrowaną w Rejestrze Przedsiębiorców Krajowego Rejestru Sądowego prowadzonym
      przez Sąd Rejonowy w Gdańsku VIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS: 298676, NIP:
      9581581485, REGON: 220559694, zwany „Usługodawcą”.</p>
  <p>Kontakt z Usługodawcą można uzyskać:</p>
  <p>- pod numerami telefonu: +48 603 244 040 (godziny pracy Portalu 8-16 w dni robocze, opłata jak za zwykłe połączenie
      telefoniczne, zgodnie z pakietem taryfowym dostawcy usług, z którego korzysta Użytkownik),</p>
  <p>- korzystając z adresu poczty elektronicznej – <a href="mailto:bok@e-containers.eu">bok@e-containers.eu</a>.</p>
  <p><strong>§ 1 POSTANOWIENIA OGÓLNE</strong></p>
  <p><strong>Ustala się nastepujące znaczenie słów:</strong></p>
  <ol>
      <li>REGULAMIN – niniejszy regulamin.</li>
      <li>PORTAL – portal internetowy stanowiący własność Usługodawcy i przez niego zarządzany, dostępny pod następującymi
          adresami internetowymi: kontenerowy.pl, e-containers.eu, econtainers.ru, e-containers.de, e-containers.pl,
          4containers.eu, 4containers.ru, 4containers.pl, 4containers.de, oraz innymi adresami określonymi na bieżąco
          przez Usługodawcę.</li>
      <li>UŻYTKOWNIK – osoba fizyczna, osoba prawna lub jednostka organizacyjna nie posiadająca osobowości prawnej,
          prowadzące działalność gospodarczą, zarejestrowana i uprawniona do korzystania z Portalu.</li>
      <li>KONTO – utworzone na rzecz Użytkownika konto w Portalu, za pomocą którego może on korzystać z usług Portalu.
      </li>
      <li>UMOWA – umowa zawierana między Użytkownikami Portalu za jego pomocą i dotycząca świadczonych przez nich usług.
      </li>
      <li>ZLECENIE WINDYKACJI – przekazywany przez Użytkownika zakres informacji dotyczący jego dłużnika umożliwiający
          Usługodawcy prowadzenie windykacji jego dłużnika.</li>
      <li>ABONAMENT – ustalona w Cenniku opłata za korzystanie z Portalu oraz świadczenia określonych w Regulaminie.
          Wysokość Abonamentu może być zmieniana w oparciu o indywidualne ustalenia z Usługodawcą przez Użytkownika, które
          mają pierwszeństwo przed Regulaminem.</li>
      <li>PROMOCJE – oferowane przez Usługodawcę zniżki, upusty lub inne udogodnienia, których warunki będą każdorazowo
          ogłaszane w odpowiedniej zakładce Portalu.</li>
      <li>FAKTURA – wystawiony przez Usługodawcę dokument księgowy, który może być wydany Użytkownikowi w formie
          papierowej albo w wersji elektronicznej zgodnie z art. 106e ustawy z dnia 11 marca 2004 r. o podatku od towarów
          i usług. W ramach świadczenia Usług Usługodawca może również wystawiać faktury pro-forma. </li>
      <li>UMOWA KONTA – umowa zawierana przez Usługodawcę z Użytkownikiem, na mocy której Użytkownik uzyskuje dostęp do
          Portalu.</li>
      <li>CENNIK – określony przez Usługodawcę cennik usług, stanowiący załącznik do Regulaminu.</li>
      <li>BAZY DANYCH – zbiory informacji dostępne w ramach Portalu, w szczególności zawierające dane Użytkowników oraz
          oferowane warunki i zasady współpracy.</li>
      <li>Przedmiotem działalności Portalu jest umożliwienie Użytkownikowi korzystania z niego celem nawiązywania
          kontaktów handlowych przedsiębiorców w zakresie szeroko rozumianego transportu, przewozu i spedycji towarów oraz
          pozasądowe odzyskiwanie przez Usługodawcę na rzecz Użytkownika bezspornych i wymagalnych wierzytelności
          Użytkownika wobec jego dłużnika.</li>
      <li>Usługodawca oświadcza, iż w ramach Portalu świadczy szereg usług dla Użytkowników określonych w niżej opisanym
          Regulaminie. Użytkownik oświadcza, iż jest przedsiębiorcą prowadzącym działalność gospodarczą oraz że chce
          korzystać z Portalu oraz usług oferowanych za jego pomocą przez Usługodawcę. </li>
      <li>Niniejszy Regulamin i zawarte w nim postanowienia zastępują umowy z klientami, którzy zawarli je uprzednio w
          formie pisemnej i dokonali zmiany aneksem.</li>
      <li>Każdy Użytkownik korzystający z usług Portalu jest obowiązany zapoznać się z treścią niniejszego Regulaminu,
          który tworzy stosunek umowny.</li>
      <li>Rejestracja i uzupełnienie przez Użytkownika danych w Koncie Użytkownika jest równoznaczne z zawarciem umowy
          pomiędzy Użytkownikiem a Usługodawcą, której przedmiotem są usługi świadczone przez Usługodawcę w ramach
          Portalu, na warunkach określonych w Regulaminie.</li>
      <li>Użytkownik wyraża zgodę, aby po dokonaniu rejestracji w Portalu, otrzymywać środkami komunikacji informacje
          systemowe oraz wiadomości od Usługodawcy. </li>
      <li>Usługodawca na żadnym etapie nie jest stroną transakcji zawieranych za pomocą Portalu. Usługodawca udostępnia
          strony internetowe, miejsce na serwerze i rozwiązania informatyczne umożliwiające zapoznanie się Użytkownikom z
          informacjami handlowymi oraz zawieranie umów pomiędzy nimi. Umowy zawierane są bezpośrednio pomiędzy
          Użytkownikami. Użytkownicy są tylko podmiotami profesjonalnymi (B2B) oraz użytkują Portal w ramach swojej
          działalności gospodarczej. Usługodawca nie świadczy usług przewozowych, a jedynie udostępnia platformę łączącą
          Użytkowników świadczących tego typu usługi.</li>
  </ol>
  <p><strong>§ 2 WARUNKI TECHNICZNE SKŁADANIA ZAMÓWIEŃ</strong> </p>
  <p>1. Wymagania techniczne niezbędne do korzystania z usług Portalu:</p>
  <p>a) podłączenie do Internetu,</p>
  <p>b) poprawnie skonfigurowana przeglądarka,</p>
  <p>c) aktualne, czynne i poprawnie skonfigurowane konto poczty elektronicznej,</p>
  <p>d) włączona obsługa Cookies i Java Script</p>
  <p>e) program do odczytu plików formatu PDF.</p>
  <p>2. W razie korzystania przez Użytkownika ze sprzętu lub oprogramowania, które nie spełnia wymogów technicznych
      określonych powyżej, Portal nie gwarantuje prawidłowości funkcjonowania Portalu i zastrzega, że może to mieć
      negatywny wpływ na jakość i przebieg procedury składania zamówienia na usługi Użytkowników.</p>
  <p>3. Użytkownik zapewnia, że będzie korzystał z Portalu zgodnie z jego przeznaczeniem i obowiązującym prawem.</p>
  <p>4. W Portalu mogą być zamieszczane wyłącznie ogłoszenia dotyczące towarów i usług, którymi obrót dopuszczają przepisy
      prawa polskiego.</p>
  <p>5. Zakazane jest dostarczanie przez Klienta treści o charakterze bezprawnym, w tym w szczególności w ogłoszeniach czy
      w publicznej komunikacji z innymi Użytkownikami.</p>
  <p>6. Klient może dokonać subskrypcji newsletteru Portalu, czyli cyklicznej wysyłki informacji o produktach i usługach
      Portalu. Aby zapisać się na newsletter Użytkownik wpisuje swój adres e-mail w formularzu newsletter znajdującym się
      na stronie internetowej Portalu, jednocześnie potwierdzając zgodę na przetwarzanie jego danych osobowych w tym celu
      i kierowanie na podany e-mail treści promocyjnych. Z newsletteru można zrezygnować w każdej chwili, a w tym celu
      Użytkownik jest proszony o przekazanie oświadczenia o rezygnacji poprzez e-mail Usługodawcy: – biuro@e-containers.eu
      lub wybranie linku rezygnacji w wiadomości e-mail dostarczanej z newsletterem.</p>
  <p><strong>§ 3 REJESTRACJA</strong></p>
  <ol>
      <li>Rejestracja w Portalu jest nieodpłatna, lecz obowiązkowa w celu korzystania z jego usług. Portal nie przewiduje
          możliwości zamieszczania ofert świadczenia usług ani ich nabywania bez rejestracji.</li>
      <li>Użytkownikami Portalu mogą być wyłącznie osoby fizyczne, osoby prawne lub jednostki organizacyjne nie
          posiadająca osobowości prawnej, prowadzące działalność gospodarczą.</li>
      <li>Rejestracja w Portalu odbywa się w oparciu o prawidłowo wypełniony formularz rejestracyjny.</li>
      <li>Po jego wypełnieniu Użytkownik uzyskuje dostęp do możliwości zamieszczenia dokumentów celem dokonania
          weryfikacji podmiotu przez Usługodawcę. Po skutecznej weryfikacji Usługodawca umożliwia Użytkownikowi dostęp do
          całości funkcji Portalu.</li>
      <li>Dokumenty, które Użytkownik zobowiązany jest zamieścić w Portalu celem umożliwienia Usługodawcy weryfikacji go
          to:</li>
  </ol>
  <p>(a) Skany aktualnego zaświadczenia o dokonaniu wpisu do ewidencji działalności gospodarczej lub aktualnego odpisu z
      KRS,</p>
  <p>(b) Skany potwierdzenia zgłoszenia rejestracyjnego podatnika podatku od towarów i usług oraz podatku akcyzowego i
      decyzji w sprawie nadania numeru identyfikacyjnego lub potwierdzenia zarejestrowania podmiotu jako podatnika VAT,
  </p>
  <p>(c) w przypadku przewoźników drogowych – skany polisy ubezpieczenia OC przewoźnika drogowego i pozwolenia na
      wykonywanie transportu drogowego,</p>
  <p>(d) w przypadku spedytorów – skany polisy ubezpieczenia OC spedytora i pozwolenia na wykonywanie transportu drogowego
      w zakresie pośrednictwa przy przewozie rzeczy.</p>
  <ol>
      <li>W przypadku niezłożenia przez Użytkownika powyższych dokumentów w celu umożliwienia Usługodawcy jego
          weryfikacji, Usługodawca usunie niezweryfikowane Konto Użytkownika z Portalu po upływie 2 miesięcy od czasu na
          ich przedstawienie. Usunięcie Konta odbywać się będzie za powiadomieniem e-mailowym Użytkownika.</li>
      <li>Dalsza weryfikacja Konta przez Usługodawcę opierać się będzie na przedłożonych przez Użytkownika żądanych przez
          usługodawcę dokumentach, ich zawartości i prawdziwości, referencji oraz na historii płatności, w szczególności
          względem Użytkowników poprzednio współpracujących z Usługodawcą.</li>
      <li>Usługodawca może odmówić umożliwienia dostępu do Portalu, jeżeli jest to uzasadnione słusznym interesem
          Usługodawca lub innych Użytkowników, a w szczególności w przypadku:</li>
  </ol>
  <p>(a) prowadzenia przez Użytkowników lub podmioty kapitałowo lub osobowo z nimi powiązane działań sprzecznych z
      powszechnie obowiązującymi przepisami, Regulaminem lub dobrymi obyczajami, w tym prowadzenia bądź reklamowania
      działalności konkurencyjnej wobec Portalu;</p>
  <p>(b) zalegania przez Użytkownika z płatnościami na rzecz innych przedsiębiorców;</p>
  <p>(c) przekazania przez Użytkownika niepełnych, nieprawdziwych lub wprowadzających w błąd informacji,</p>
  <p>(d) prowadzenia przez Użytkownika działalności gospodarczej przez okres nieprzekraczający jednego roku,</p>
  <p>(e) uzyskania informacji o toczącym się̨ postępowaniu upadłościowym, układowym, naprawczym lub likwidacyjnym
      Użytkownika, </p>
  <p>(f) zawieszenia albo zamknięcia prowadzenia działalności gospodarczej przez Użytkownika;</p>
  <p>(g) zmiany składu udziałowców lub akcjonariuszy w ponad 50% udziału kapitałowego Użytkownika lub zmiany składu
      osobowego w spółce osobowej w ponad 50% składu w ciągu 2 lat poprzedzających dzień zawarcia Umowy.</p>
  <ol>
      <li>W przypadku uzasadnionych wątpliwości Usługodawca może uzależnić korzystanie z Portalu od przedstawienia w
          oryginale lub poświadczone kopii dokumentów, o których mowa powyżej lub innych dokumentów potwierdzających dane
          identyfikujące Użytkownika.</li>
      <li>Po spełnieniu powyższego Użytkownik zobowiązany jest do wyboru abonamentu w celu uzyskania pełni dostępu do
          funkcjonalności Portalu. W tym celu Użytkownik wybiera jeden z pakietów abonamentowych dostępnych w ofercie
          Usługodawcy i dokonuje jego opłacenia w sposób wskazany na stronie Portalu. Dopiero po jego opłaceniu i
          zaksięgowaniu płatności na koncie Usługodawcy, Użytkownik uzyska dostęp do pełni funkcji Portalu. </li>
      <li>Sam proces rejestracji i dostęp do możliwości umieszczenia dokumentów w Portalu są bezpłatne. W przypadku braku
          zakupu abonamentu, Użytkownik nie będzie miał możliwości korzystania z Portalu ponad możliwość zamieszczenia
          dokumentów weryfikacyjnych i podstawową edycję swojego Konta.</li>
      <li>Podane dane identyfikujące Użytkownika oraz umieszczone na Portalu skany dokumentów, o których mowa powyżej,
          będą jawne i dostępne dla innych Użytkowników Portalu, na co Użytkownik wyraża zgodę.</li>
      <li>Użytkownik w momencie rejestracji wyraża zgodę na umieszczenie na Portalu i przetwarzanie przez Usługodawcę
          swoich danych osobowych oraz wizerunku na zasadach określonych poniżej w Regulaminie.</li>
      <li>Użytkownikowi nie wolno korzystać z kont innych Użytkowników, ani odstępować swojego konta osobom trzecim.
          Użytkownik nie będzie ujawniał osobom trzecim, ani wykorzystywał do celów innych niż kontakt z potencjalnym
          kontrahentem ani wykorzystywał w sposób sprzeczny z prawem, danych innych Użytkowników Portalu. Zakazane jest
          pobieranie danych z Portalu celem świadczenia usług konkurencyjnych w stosunku do tych świadczonych przez
          Usługodawcę lub celem ich dalszego udostępniania podmiotom konkurencyjnym.</li>
      <li>Użytkownik ma możliwość dostępu i zmian danych go identyfikujących i dokumentów, o których mowa powyżej oraz ma
          obowiązek aktualizować dane go identyfikujące oraz powyższe dokumenty niezwłocznie po każdej zmianie ich
          dotyczącej, nie później niż w ciągu 2 dni roboczych.</li>
      <li>Użytkownikowi nie wolno jest usuwać z Portalu danych go identyfikujących, ani dokumentów, o których mowa powyżej
          bez uprzedniej pisemnej zgody Usługodawcy, chyba że dokonuje powyższego w ramach przysługujących mu uprawnień
          przewidzianych przez RODO a wskazanych w dalszej części Regulaminu..</li>
      <li>W celu usunięcia Konta Użytkownika z Portalu (wypowiedzenie umowy) należy wysłać wiadomość elektroniczną z
          wnioskiem o usunięcie konta na adres e-mail: <a href="mailto:bok@e-containers.eu">bok@e-containers.eu</a> z
          podaniem danych identyfikujących Użytkownika aktualnie zarejestrowanego w Portalu. Wypowiedzenie odniesie skutek
          na koniec okresu wypowiedzenia (3 miesiące ze skutkiem na koniec miesiąca).</li>
  </ol>
  <p><strong>§ 4 WARUNKI KORZYSTANIA Z PORTALU</strong></p>
  <ol>
      <li>.Ogłoszenie zamieszczone na Portalu stanowi wyłącznie informację o możliwości wykonania usługi przez
          ogłaszającego się Użytkownika i nie stanowi oferty w rozumieniu art. 66 kodeksu cywilnego. Ogłoszenie
          zamieszczone na Portalu stanowi wyłącznie oświadczenie Użytkownika o chęci wykonania danej usługi i stanowi
          zaproszenie do negocjacji szczegółowych warunków transakcji. Każdy z Użytkowników może samodzielnie podejmować
          decyzje dotyczące nawiązania stosunków umownych z innymi użytkownikami Portalu, nie jest przy tym w
          szczególności związany kolejnością składania lub przyjmowania finalnych ofert.</li>
      <li>Użytkownik może zamieszczać na Portalu oferty jak również będzie miał dostęp do ofert zamieszczonych na Portalu
          przez innych Użytkowników.</li>
      <li>Oferty zamieszczane na Portalu będą jawne i dostępne dla innych Użytkowników Portalu, na co Użytkownik wyraża
          niniejszym zgodę.</li>
      <li>W Portalu mogą być zamieszczane wyłącznie oferty dotyczące towarów i usług, które odpowiadają profilowi Portalu.
      </li>
      <li>Po zakończeniu transakcji, strony transakcji mogą sobie wystawić wzajemnie komentarze, które będą umieszczone na
          Portalu.</li>
      <li>W Portalu w zakładce „Promocje” Usługodawca może oferować Użytkownikom preferencyjne warunki świadczenia Usług.
          Takie warunki mogą być ponadto oferowane w Umowach zawieranych z poszczególnymi Użytkownikami.</li>
      <li>Z przyczyn technicznych, zabroniony jest dostęp do Portalu przy użyciu jakichkolwiek innych programów poza
          przeglądarkami internetowymi. Dotyczy to w szczególności tzw. botów, a także innych narzędzi, które symulują,
          zastępują lub uzupełniają interfejs strony. Ponadto zabrania się używania skryptów oraz całkowicie lub częściowo
          zautomatyzowanych programów, które dają Użytkownikowi przewagę nad innymi Użytkownikami Portalu. Do tego zalicza
          się także kompletnie lub częściowo zautomatyzowane programy, które umożliwiają samoaktualizację (auto-refresh),
          oraz inne dodatkowe mechanizmy, które nie są zintegrowane fabrycznie z przeglądarkami internetowym.</li>
      <li>W przypadku wyboru przez Użytkownika oferty wystawionej w Portalu, wystawiający ją Użytkownik ponosi pełną
          odpowiedzialność za wykonanie tak zawartej Umowy i jednocześnie jest jedyną stroną takiej Umowy. W szczególności
          dotyczy to odpowiedzialności za:</li>
  </ol>
  <p>(a) zgodność oferty z wymogami prawa (w tym uwzględnienie obowiązków informacyjnych względem kontrahenta), dokładność
      i zgodność z prawdą parametrów produktu, wysokość żądanej ceny, dostępność oraz zgodność fotografii zamieszczonych
      na stronie Portalu z rzeczywistością,</p>
  <p>(b) posiadanie przez Użytkownika wszelkich niezbędnych dokumentów, instrukcji i atestów wymaganych prawem,</p>
  <p>(c) terminowe i zgodne z Umową jej wykonanie.</p>
  <ol>
      <li>Użytkownik zobowiązany jest do opłacenia Umowy w ciągu 5 dni roboczych liczonych od momentu dokonania jej
          zawarcia. W przypadku nagminnego niewywiązywania się przez Użytkownika z obowiązku opłacenia Umowy Usługodawca
          ma prawo zablokować Użytkownikowi możliwość korzystania z Portalu.</li>
  </ol>
  <p><strong>§ 5 USŁUGI WINDYKACJI</strong></p>
  <ol>
      <li>Usługodawca informuje, że w ramach usług świadczonych przez niego na Portalu znajduje się możliwość zlecenia mu
          windykacji dłużników Użytkownika, w zakresie wierzytelności bezspornych i wymagalnych na etapie przedsądowym.
      </li>
      <li>W celu skorzystania z tej usługi, należy powiadomić Usługodawcę o tym fakcie za pomocą funkcjonalności Portalu i
          przekazać mu wszystkie niezbędne do tego celu dokumenty poświadczające istnienie wierzytelności, jej wymagalność
          oraz tożsamość dłużnika.</li>
      <li>Dokładne warunki świadczenia usług windykacji przez Usługodawcę opisane są w załączniku do niniejszego
          Regulaminu pt. „Warunki Windykacji”. Postanowienia znajdujące się w załączniku stanowią integralną część
          niniejszego Regulaminu.</li>
      <li>Ponadto Usługodawca na życzenie Użytkownika może skontaktować go ze współpracującymi z Usługodawcą
          przedsiębiorcami zajmującymi się windykacją należności.</li>
  </ol>
  <p><strong>§ 6 ODPOWIEDZIALNOŚĆ USŁUGODAWCY</strong></p>
  <ol>
      <li>Usługodawca nie jest stroną w stosunkach handlowych nawiązanych przez Użytkowników Portalu. W szczególności
          Usługodawca nie pośredniczy w nawiązaniu stosunków handlowych pomiędzy Użytkownikami Portalu; Usługodawca
          jedynie udostępnia swoje strony internetowe celem umożliwienia Użytkownikom Portalu nawiązania kontaktów
          handlowych.</li>
      <li>Usługodawca nie ma możliwości, ani nie pełni nadzoru nad transakcjami zawieranymi przez Użytkowników Portalu. W
          szczególności Usługodawca nie sprawdza, ani nie ponosi odpowiedzialności za treść i prawdziwość ofert,
          zachowanie Użytkowników, ich uczciwość, ani wywiązywanie się przez Użytkowników z zawartych umów i innych
          zobowiązań.</li>
      <li>Usługodawca nie pośredniczy w nawiązaniu stosunków handlowych pomiędzy Użytkownikami Portalu. W szczególności
          Usługodawca nie działa jako pełnomocnik bądź przedstawiciel jakiegokolwiek Użytkownika, nie jest też niczyim
          agentem w rozumieniu przepisów Kodeksu cywilnego.</li>
      <li>Usługodawca nie odpowiada za towary i usługi oferowane przez Użytkowników Portalu, a w szczególności za ich
          jakość, bezpieczeństwo, legalność, prawdziwość i rzetelność ich opisu.</li>
      <li>Usługodawca nie weryfikuje informacji podawanych przez Użytkowników Portalu, ani zamieszczonych przez nich
          dokumentów na Portalu, w tym pod kątem autentyczności czy kompletności.</li>
      <li>Usługodawca nie jest zobowiązany i nie ma technicznej możliwości zbadania czy Użytkownik Portalu prowadzi
          działalność gospodarczą zgodnie z przepisami, w szczególności czy uzyskał stosowne zezwolenia, licencje itp.
          Usługodawca nie ponosi odpowiedzialności za szkody poniesione przez Użytkowników w wyniku ewentualnych braków po
          stronie innych Użytkowników w w/w zakresie.</li>
      <li>Usługodawca nie ponosi odpowiedzialność za treść komentarzy, jednakże w uzasadnionych przypadkach może usunąć
          komentarz z Portalu.</li>
      <li>Usługodawca nie ponosi odpowiedzialności za awarie Portalu wynikłe z przyczyn od niego niezależnych. Usługodawca
          nie ponosi odpowiedzialności w szczególności za okresowe wyłączenie lub ograniczenie dostępu do Portalu oraz
          usług lub utratę części lub wszystkich danych Użytkowników znajdujących się w Portalu oraz na serwerach
          Usługodawcy.</li>
      <li>Usługodawca dołoży wszelkich starań, aby Portal oraz usługi działały w sposób ciągły bez jakichkolwiek zakłóceń.
          Usługodawca dołoży wszelkich starań aby możliwie jak najszybciej usuwać wszelkie ewentualne usterki Portalu oraz
          usług. Usługodawca jest uprawniony do wprowadzania ewentualnych przerw konserwacyjnych.</li>
      <li>Usługodawca zastrzega sobie prawo do publikowania w Portalu informacji o Użytkownikach, którzy w sposób
          uporczywy naruszają Regulamin lub w ten sam sposób podejmują działania sprzeczne z Regulaminem, obowiązującymi
          przepisami, dobrymi obyczajami lub celem i charakterem Portalu. Użytkownik niniejszym wraża zgodę na
          przetwarzanie jego danych osobowych w w/w celu.</li>
      <li>W każdym przypadku Usługodawca jest odpowiedzialny za szkody wyrządzone Użytkownikowi wyłącznie z winy umyślnej.
      </li>
      <li>Usługodawca nie ponosi odpowiedzialności za bezprawne wykorzystywanie cudzej własności intelektualnej, w tym w
          szczególności praw ochronnych do znaków towarowych przez Użytkowników oraz za naruszenie przez Użytkowników praw
          autorskich oraz innych praw Użytkowników lub osób trzecich.</li>
  </ol>
  <p><strong>§ 7 ODPOWIEDZIALNOŚĆ UŻYTKOWNIKÓW</strong></p>
  <ol>
      <li>Użytkownicy ponoszą pełną odpowiedzialność za niewłaściwe korzystanie z Portalu i niestosowanie się do
          postanowień niniejszego Regulaminu. Zabrania się Użytkownikom zamieszczania w Portalu treści, które:</li>
  </ol>
  <ul>
      <li>są sprzeczne z obowiązującym prawem,</li>
      <li>naruszają prawa osób trzecich,</li>
      <li>naruszają prawa autorskie,</li>
      <li>są powszechnie uznawane za wulgarne lub obelżywe,</li>
      <li>wzywają do nienawiści na tle rasowym, wyznaniowym lub etnicznym,</li>
      <li>nawołują do aktów przemocy,</li>
      <li>obrażają Użytkowników lub inne osoby,</li>
      <li>promują inne strony internetowe,</li>
      <li>promują programy partnerskie firm trzecich,</li>
      <li>zawierają treści o charakterze pornograficznym,</li>
      <li>zawierają treści o charakterze reklamowym,</li>
      <li>stanowią linki prowadzące do stron zawierających treści opisane w tym paragrafie.</li>
  </ul>
  <ol>
      <li>W wypadku zamieszczenia przez Użytkownika treści stanowiących naruszenie Regulaminu mogą one zostać usunięte
          przez Usługodawcę, bez informowania Użytkownika o tym fakcie. </li>
      <li>Zakazane są wszelkie działania mogące utrudniać lub destabilizować działanie Portalu. W przypadku stwierdzenia
          przez Usługodawcę, że Użytkownik dopuszcza się takich działań, Usługodawca niezwłocznie zawiesi lub usunie Konto
          takiego Użytkownika. W takiej sytuacji Usługodawca podejmie również wszelkie działania prawne mające na celu
          naprawienie poniesionej przez niego szkody.</li>
      <li>Użytkownik ponosi pełną odpowiedzialność materialną za szkodę wyrządzoną Usługodawcy, w następstwie użycia nazwy
          firmy lub znaków towarowych Usługodawcy, bez jego zgody lub niezgodnie z Regulaminem.</li>
  </ol>
  <p><strong>§ 8 CENNIK I OPŁATY</strong></p>
  <ol>
      <li>Użytkownik obowiązany jest uiszczać Abonament za korzystanie z Portalu, na warunkach określonych w Regulaminie
          oraz Cenniku zawartym w załączniku „Cennik” do niniejszego Regulaminu.</li>
      <li>Wysokość Abonamentu, zasady jego płatności, promocje określone w ramach Portalu mogą być zmieniane na mocy
          indywidualnych ustaleń między Usługodawcą a Użytkownikiem.</li>
      <li>Wysokość Abonamentu oraz poszczególne jego rodzaje zostały określone w Cenniku. Użytkownik wybiera opcję z
          Abonamentów w Portalu po zalogowaniu.</li>
      <li>W przypadku uiszczenia przez Użytkownika Abonamentu na preferencyjnych warunkach z góry, w ramach uiszczonej
          kwoty Użytkownik będzie uprawniony do korzystania z Portalu przez okres dłuższy niż standardowy okres wynikający
          z Cennika (np. Abonament uiszczony za 6 miesięcy z góry uprawnia Użytkownika do korzystania z Portalu przez
          okres 7 miesięcy). Zasady uiszczania i korzystania z preferencyjnych Abonamentów określone zostały w Cenniku. W
          przypadku wykupienia Abonamentu na preferencyjnych warunkach, w razie rozwiązania stosunku umownego wcześniej,
          Abonament uiszczony przez Użytkownika z góry nie podlega zwrotowi.</li>
      <li>Użytkownika obowiązuje w danym okresie rozliczeniowym Cennik, który zaakceptował w momencie podpisywania Umowy.
          Archiwalne Cenniki dostępne są u Usługodawcy.</li>
      <li>Użytkownik zobowiązany jest uiszczać Abonament z góry, w terminie do 15 dnia każdego miesiąca, na podstawie
          faktury VAT wystawionej przez Usługodawcę, na rachunek bankowy wskazany w treści faktury.</li>
      <li>Do abonamentu będzie każdorazowo doliczany podatek VAT w obowiązującej, w chwili wystawienia faktury, wysokości.
          Za dzień zapłaty uważany będzie dzień uznania rachunku Usługodawcy.</li>
      <li>Użytkownik wyraża zgodę na wystawianie i przesyłanie przez Usługodawcę faktur w formie elektronicznej, za
          pośrednictwem e-mail, a także przechowywanie oraz udostępnianie organowi podatkowemu lub organowi kontroli
          skarbowej tych faktur, zgodnie z art. 106e ustawy z dnia 11 marca 2004 r. o podatku od towarów i usług. Faktury
          będą kierowane na adres mailowy podany przez Użytkownika wskazany przy rejestracji, a Użytkownik oświadcza, że w
          przypadku zmiany tego adresu poinformuje o tym Usługodawcę. </li>
      <li>Usługodawca zastrzega sobie prawo do zmiany Cennika. O zmianie Cennika Usługodawca powiadomi zarejestrowanych
          Użytkowników drogą e-mailową z prawem wypowiedzenia umowy w terminie 30 dni od powiadomienia. Zmiany Cennika
          wchodzą w życie wraz z nowym okresem rozliczeniowym, po upływie okresu na wypowiedzenie.</li>
  </ol>
  <p><strong>§ 9 BLOKADA KONTA UŻYTKOWNIKA</strong></p>
  <ol>
      <li>Umowa o prowadzenie konta Użytkownika została zawarta na czas nieokreślony w momencie sukcesywnego opłaceniu
          Abonamentu i utrzymywania Konta. </li>
      <li>Każda ze stron może rozwiązać niniejszą Umowę, z zachowaniem 3-miesięcznego okresu wypowiedzenia, ze skutkiem na
          koniec miesiąca kalendarzowego. </li>
      <li>Usługodawca może niezwłocznie zablokować konto Użytkownika oraz rozwiązać Umowę w trybie natychmiastowym, bez
          prawa do jakiegokolwiek odszkodowania z tego tytułu oraz bez prawa żądania zwrotu uiszczonego bądź wymagalnego
          Abonamentu, na zasadach i w przypadkach określonych w Regulaminie. </li>
      <li>Blokada Konta oraz wypowiedzenie Umowy mogą nastąpić na zasadach określonych w niniejszym Regulaminie.</li>
      <li>Usługodawca może niezwłocznie zablokować konto Użytkownika oraz rozwiązać umowę o korzystanie z Portalu bez
          prawa do jakiegokolwiek odszkodowania z tego tytułu, jeżeli:</li>
  </ol>
  <p>(a) Użytkownik opóźnia się z płatnością Abonamentu o więcej niż 7 (siedem) dni;</p>
  <p>(b) Użytkownik poda nieprawdziwe informacje lub zamieści na Portalu nieautentyczne lub przerobione dokumenty, o
      których mowa powyżej,</p>
  <p>(c) Użytkownik umieści na Portalu ofertę dotyczącą towarów lub usług, którymi obrót jest zakazany,</p>
  <p>(d) Użytkownik naruszy postanowienia Regulaminu lub obowiązujące przepisy prawa, </p>
  <p>(e) Użytkownik wprowadzi w błąd innych Użytkowników Portalu lub naruszy ich interesy;</p>
  <p>(f) w innych przypadkach, gdy działania Użytkownika będą naruszały interesy Usługodawcy, utrudniały działanie
      Portalu, podważały zaufanie i naruszały dobre imię Portalu lub Usługodawcy lub gdy Usługodawca z innych ważnych
      powodów uzna to za uzasadnione.</p>
  <ol>
      <li>Zablokowanie konta Użytkownika następuje poprzez czynność techniczną, tj. uniemożliwienie Użytkownikowi
          korzystania z Portalu przy pomocy przypisanego mu loginu i hasła.</li>
      <li>Zablokowanie konta nie zwalnia Użytkownika z obowiązku uiszczania abonamentu.</li>
      <li>W okresie, za który Użytkownik nie uiścił w terminie abonamentu Usługodawca może ograniczyć dostęp do Usług.
      </li>
  </ol>
  <p><strong>§ 10 WŁASNOŚĆ INTELEKTUALNA</strong></p>
  <ol>
      <li>Całość praw autorskich, znaki towarowe i inne prawa własności intelektualnej związane lub dotyczące Portalu
          przysługują Usługodawcy i podlegają ochronie prawnej.</li>
      <li>Korzystanie z Portalu na podstawie Regulaminu oraz umowy o prowadzenie konta, nie oznacza nabycia przez
          Użytkownika jakichkolwiek praw własności intelektualnej do Portalu oraz jego elementów. </li>
      <li>Zabronione jest w szczególności kopiowanie, modyfikowanie oraz transmitowanie elektronicznie lub w inny sposób
          Portalu lub jego części, bez uprzedniej pisemnej zgody Usługodawcy, korzystanie z Portalu w sposób niezgodny z
          Regulaminem, umową o prowadzenie konta lub powszechnie obowiązującymi przepisami; niszczenie, uszkadzanie,
          usuwanie lub zmienianie danych informatycznych, tekstowych i graficznych Portalu lub zakłócanie jego działania w
          inny sposób; pobieranie zawartości Portalu, w szczególności baz danych i wtórne ich wykorzystywanie w całości
          lub w części, bez uprzedniej pisemnej zgody Usługodawcy.</li>
      <li>Użytkownik wyraża zgodę na wykorzystywanie przysługujących mu praw własności intelektualnej i przemysłowej, w
          tym nazw handlowych i znaków towarowych celem korzystania z Portalu oraz w celach promocyjnych i marketingowych
          Usługodawcy.</li>
      <li>W przypadku stwierdzenia naruszenia przez Użytkownika niniejszych postanowień niezależnie od innych uprawnień
          przewidzianych w Regulaminie, Usługodawca będzie uprawniony do nałożenia na Użytkownika kary umownej w wysokości
          50.000,00 zł (pięćdziesiąt tysięcy złotych) za każde stwierdzone naruszenie tychże postanowień. Powyższe nie
          wyłącza możliwości dochodzenia odszkodowania przewyższającego wysokość zastrzeżonej kary.</li>
  </ol>
  <p><strong>§ 11 REKLAMACJE</strong></p>
  <ol>
      <li>Wszelkie reklamacje dotyczące działania Portalu Użytkownik może składać w formie pisemnej na adres Usługodawcy
          wskazany na początku Regulaminu lub drogą elektroniczną na adres <a
              href="mailto:bok@e-containers.eu">bok@e-containers.eu</a>.</li>
      <li>W celu złożenia reklamacji należy poinformować Portal o zaobserwowanych wadach, udokumentować je celem dokonania
          weryfikacji zastrzeżeń oraz ewentualnego usunięcia wad przez Usługodawcę, który poinformuje składającego
          reklamację o tym w terminie do 30 dni od zgłoszenia reklamacji. Reklamacja powinna dodatkowo zawierać: imię i
          nazwisko albo firmę (nazwę) oraz adres zamieszkania bądź siedziby Użytkownika; szczegółowy opis reklamacji;
          przedstawienie okoliczności uzasadniających reklamację.</li>
      <li>W przypadku, gdy złożona reklamacja nie spełnia warunków określonych powyżej Usługodawca powiadomi Użytkownika o
          konieczności jej uzupełnienia, określając termin, nie krótszy niż 7 dni, i zakres tego uzupełnienia, z
          pouczeniem, że nieuzupełnienie reklamacji w określonym terminie spowoduje pozostawienie reklamacji bez
          rozpoznania. Po bezskutecznym upływie wyznaczonego terminu reklamację pozostawia się bez rozpoznania.</li>
      <li>Usługodawca zastrzega sobie prawo przedłużenia 30-dniowego terminu na odpowiedź w sytuacji, w której udzielenie
          odpowiedzi uzależnione jest od zebrania dodatkowych informacji o czym poinformuje niezwłocznie Użytkownika.
      </li>
      <li>Odpowiedzi na reklamację Usługodawca udziela pisemnie na adres siedziby Użytkownika lub drogą elektroniczną na
          wskazany przez Użytkownika adres poczty elektronicznej.</li>
      <li>Użytkownik ponosi pełną odpowiedzialność za treści umieszczone w reklamacji.</li>
  </ol>
  <p><strong>§ 12 OCHRONA DANYCH OSOBOWYCH</strong></p>
  <ol>
      <li>Usługodawca jest administratorem danych osobowych i przetwarza je zgodnie z Ogólnym Rozporządzeniem o Ochronie
          Danych Osobowych, Ustawą o ochronie danych osobowych i jej nowelizacjami oraz Ustawą o świadczeniu usług drogą
          elektroniczną z dnia 18.07.2002 r. („Administrator”).</li>
      <li>W przypadku przetwarzania danych osobowych na podstawie przesłanego przez Użytkownika e-maila lub reklamacji
          przetwarzanie takie następuje na podstawie art. 6 ust. 1 lit. b Ogólnego Rozporządzenia o Ochronie Danych,
          zgodnie z którym przetwarzanie danych jest konieczne w celu podjęcia działań na żądanie osoby, której dane
          dotyczą. </li>
      <li>W przypadku uzyskania odrębnej zgody użytkownika, jego dane osobowe mogą być przetwarzane przez administratora
          również w celach marketingowych, w tym w celu kierowania informacji handlowej drogą elektroniczną na wskazany
          przez użytkownika adres e-mail (art. 6 ust. 1 lit. a Ogólnego Rozporządzenia o Ochronie Danych).</li>
      <li>W przypadku zawierania i wykonywania przez Administratora umowy sprzedaży lub umów o świadczenie usług druga
          strona ma obowiązek podać dane niezbędne dla zawarcia umowy (co jest wymogiem umownym, a w zakresie numerów
          podatkowych także wymogiem ustawowym) i w tym celu Administrator przetwarza dane osobowe (art. 6 ust. 1 lit. b
          Ogólnego Rozporządzenia o Ochronie Danych).</li>
      <li>W przypadku przeprowadzania badań i analiz w celu poprawy działania dostępnych usług (np. narzędzia śledzące)
          jako podstawę przetwarzania danych wskazuje się art. 6 ust. 1 lit. f Ogólnego Rozporządzenia o Ochronie Danych.
      </li>
      <li>Dane osobowe użytkowników przechowywane są nie dłużej niż jest to niezbędne do osiągnięcia celu przetwarzania,
          tj. do momentu cofnięcia zgody jeżeli przetwarzanie odbywa się w oparciu o taką zgodę, do momentu przedawnienia
          roszczeń Administratora i drugiej strony w zakresie realizacji zawartych umów (w przypadku umów sprzedaży/umów o
          świadczenie usług 2 lata, licząc do końca roku) oraz do momentu realizacji zapytania kierowanego za pomocą
          e-mail lub do czasu zakończenia rozpatrywania reklamacji.</li>
      <li>Administrator może korzystać z profilowania do celów marketingu bezpośredniego, ale decyzje podejmowane na jego
          podstawie przez Administratora nie dotyczą zawarcia lub odmowy zawarcia umowy, czy też możliwości korzystania z
          usług elektronicznych. </li>
      <li>W zakresie niezbędnym do prawidłowego funkcjonowania strony internetowej, jej funkcjonalności strona może,
          podczas korzystania z niej przez Użytkownika, gromadzić inne informacje, w tym między innymi:</li>
  </ol>
  <ul>
      <li>adres IP;</li>
      <li>rodzaj platformy, </li>
      <li>ustawienia i komponenty, </li>
      <li>zainstalowane oprogramowanie</li>
      <li>obecność niezbędnych wtyczek;</li>
      <li>przybliżone dane geolokalizacyjne (opracowane na podstawie adresu IP lub ustawień urządzenia);</li>
      <li>dane dotyczące przeglądarki internetowej, w tym rodzaj przeglądarki i preferowany język; </li>
  </ul>
  <ol>
      <li>Administrator zapewnia, że wszelkie zebrane dane osobowe służą do realizacji zobowiązań wobec u\Użytkowników.
          Informacje te nie będą udostępniane osobom trzecim za wyjątkiem sytuacji, gdy:</li>
  </ol>
  <ul>
      <li>uprzednio zostanie wyrażona wyraźna zgoda osób, których one dotyczą, na takie działanie, lub</li>
      <li>jeżeli obowiązek przekazania tych danych wynika lub będzie wynikać z obowiązujących przepisów prawa, np. organom
          ścigania.</li>
  </ul>
  <ol>
      <li>Dodatkowo dane osobowe usługobiorców i klientów mogą być przekazywane następującym odbiorcom lub kategoriom
          odbiorców: </li>
  </ol>
  <ul>
      <li>dostawcy usług zaopatrujący Administratora w rozwiązania techniczne, informatyczne oraz organizacyjne,
          umożliwiające Administratorowi prowadzenie działalności gospodarczej, w tym strony internetowej i świadczonych
          za jego pośrednictwem usług elektronicznych (w szczególności dostawcy oprogramowania komputerowego, agencje
          marketingowe, dostawcy poczty elektronicznej i hostingu, dostawcy oprogramowania do zarządzania firmą i
          udzielania pomocy technicznej Administratorowi oraz operatorowi dostawy produktu).</li>
      <li>dostawcy usług księgowych, prawnych i doradczych zapewniający Administratorowi wsparcie księgowe, prawne lub
          doradcze (w szczególności biuro księgowe, kancelaria prawna lub firma windykacyjna).</li>
  </ul>
  <ol>
      <li>Administrator może udostępniać dane zanonimizowane (tj. takie, które nie identyfikują konkretnych Użytkowników)
          zewnętrznym usługodawcom w celu lepszego rozpoznania atrakcyjności reklam i usług dla użytkowników, a w tym
          zakresie ze względu na siedzibę dostawców oprogramowania dane mogą być przekazywane – z zachowaniem zasad ich
          ochrony – do państw trzecich, zapewniających jednak standardowy postanowień umownych zatwierdzonych przez
          Komisję Europejską w zakresie przetwarzania danych osobowych lub mających stosowne uprawnienia do takiego
          działania na podstawie bilateralnych umów powierzenia przetwarzania danych między Unią Europejską a danym
          państwem trzecim, przy tym nie będącym członkiem Europejskiego Obszaru Gospodarczego. Tymi podmiotami w
          przypadku Administratora są: </li>
  </ol>
  <ul>
      <li>Google LLC. (siedziba: 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA) dla narzędzi Google Analytics
          służącego do analizy statystyk serwisów WWW, Google Tag manager: służącego do zarządzania skryptami poprzez
          łatwe dodawanie fragmentów kodu do witryny lub aplikacji oraz śledzenia działań wykonywanych przez użytkowników
          w witrynie WWW, Google Ads służącego do wyświetlania linków sponsorowanych w wynikach wyszukiwania wyszukiwarki
          Google i na stronach współpracujących w ramach programu Google AdSense,</li>
      <li>Meta Platforms, Inc. (siedziba: 1601 Willow Road Menlo Park, CA 94025, USA) dla Facebook pixel służącego do
          śledzenia konwersji z reklam portalu Facebook, optymalizowania ich na podstawie zebranych danych i statystyk
          oraz budowania listy odbiorców ukierunkowanej na przyszłe reklamy.</li>
  </ul>
  <ol>
      <li>Strona Administratora może korzystać z funkcjonalności Google Analytics, usługi analizy oglądalności stron
          internetowych udostępnianej przez Google, LLC. ("Google"). Więcej informacji o tym, w jaki sposób Google
          Analytics gromadzi i wykorzystuje dane, można znaleźć na oficjalnej stronie Google pod adresem:
          www.google.com/policies/privacy/partners. Ponadto każdy Użytkownik może zapobiec gromadzeniu i przetwarzaniu
          przez Google danych dotyczących jego korzystania z witryny internetowej, pobierając i instalując wtyczkę do
          przeglądarki pod następującym linkiem: <a
              href="http://tools.google.com/dlpage/gaoptout">http://tools.google.com/dlpage/gaoptout</a>.</li>
      <li>Użytkownik, którego dane osobowe są przetwarzane ma prawo do:</li>
  </ol>
  <ul>
      <li>dostępu, sprostowania, ograniczenia, usunięcia lub przenoszenia (art. 15-21 Rozporządzenia RODO). </li>
      <li>cofnięcia zgody w dowolnym momencie (na podstawie art. 6 ust. 1 lit. a) lub art. 9 ust. 2 lit. a) Rozporządzenia
          RODO),</li>
      <li>wniesienia skargi do organu nadzorczego – organem nadzorczym w Polsce jest Prezes Urzędu Ochrony Danych
          Osobowych w Warszawie. </li>
      <li>sprzeciwu – (art. 6 ust. 1 lit. e) lub f) RODO).</li>
      <li>sprzeciwu dot. marketingu bezpośredniego.</li>
  </ul>
  <ol>
      <li>Realizacja powyższych praw odbywa się na podstawie żądania użytkownika przesłanego na adres poczty
          elektronicznej biuro@e-containers.eu. Żądanie takie powinno zawierać imię i nazwisko użytkownika.</li>
      <li>Użytkownik zapewnia, że podawane lub publikowane przez niego w Portalu dane są poprawne. </li>
  </ol>
  <p><strong>§ 13 POSTANOWIENIA KOŃCOWE</strong></p>
  <ol>
      <li>Prawem właściwym jest prawo polskie. Wszelkie spory wynikające z Regulaminu lub powstające w związku z nim będą
          rozstrzygane przez sąd powszechny właściwy dla siedziby Usługodawcy. Niniejszy Regulamin podlega przepisom prawa
          polskiego i zgodnie z nimi będzie interpretowany. </li>
      <li>Usługodawca zastrzega sobie prawo do zmiany niniejszego Regulaminu.</li>
      <li>Informacja o planowanej zmianie Regulaminu zostanie, co najmniej na 30 dni przed wprowadzeniem zmian w życie,
          wysłana na adres e-mail Użytkownika przypisany do jego Konta.</li>
      <li>W przypadku, gdy Usługobiorca nie sprzeciwi się planowanym zmianom do chwili wejścia ich w życie przyjmuje się,
          że je akceptuje.</li>
      <li>W przypadku braku akceptacji dla planowanych zmian, Użytkownik powinien wysłać informację o tym na adres e-mail
          biuro@e-containers.eu, co będzie skutkować niezwłocznym rozwiązaniem umowy o świadczenie usług w ramach Portalu,
          w tym usługi prowadzenia konta.</li>
  </ol>
  <p><strong>ZAŁĄCZNIK DO REGULAMINU</strong></p>
  <p><strong>„CENNIK”</strong></p>
  <p><strong>kontenerowy.pl, e-containers.eu, econtainers.ru, e-containers.de, e-containers.pl, 4containers.eu,
          4containers.ru, 4containers.pl, 4containers.de</strong></p>
  <table>
      <tr>
          <td>
              <p>ABONAMENT I DODATKI</p>
          </td>
          <td>
              <p>OPŁATA MIESIĘCZNA NETTO</p>
          </td>
          <td>
              <p>OPCJE, UPRAWNIENIA</p>
          </td>
      </tr>
      <tr>
          <td>
              <p>Transportowy Basic </p>
          </td>
          <td>
              <p>195,00 zł</p>
          </td>
          <td>
              <p>- 1 aktywne stanowisko</p>
              <p>- publikacja ofert w giełdach:</p>
              <p>WOLNE POJAZDY, KONTENERY POIMPORTOWE</p>
              <p>- rezerwacje ofert w giełdach IMPORT i EKSPORT</p>
          </td>
      </tr>
      <tr>
          <td>
              <p>Transportowy Pro</p>
          </td>
          <td>
              <p>320,00 zł</p>
          </td>
          <td>
              <p>- 3 aktywne stanowiska</p>
              <p>- powiadomienia SMS</p>
              <p>- publikacja ofert w giełdach:</p>
              <p>WOLNE POJAZDY, KONTENERY POIMPORTOWE</p>
              <p>- rezerwacje ofert w giełdach:</p>
              <p>ŁADUNKI IMPORTOWE, ŁADUNKI EKSPORTOWE</p>
          </td>
      </tr>
      <tr>
          <td>
              <p>Spedycyjny Basic</p>
          </td>
          <td>
              <p>440,00 zł</p>
          </td>
          <td>
              <p>- 1 aktywne stanowisko</p>
              <p>- publikacja ofert w giełdach:</p>
              <p>ŁADUNKI IMPORTOWE, ŁADUNKI EKSPORTOWE,</p>
              <p>WOLNE POJAZDY, KONTENERY POIMPORTOWE</p>
              <p>- rezerwacja ofert we wszystkich giełdach</p>
          </td>
      </tr>
      <tr>
          <td>
              <p>Spedycyjny Pro</p>
          </td>
          <td>
              <p>700,00 zł</p>
          </td>
          <td>
              <p>- 5 aktywnych stanowisk</p>
              <p>- powiadomienia SMS</p>
              <p>- publikacja ofert w giełdach:</p>
              <p>ŁADUNKI IMPORTOWE, ŁADUNKI EKSPORTOWE,</p>
              <p>WOLNE POJAZDY, KONTENERY POIMPORTOWE</p>
              <p>- rezerwacja ofert we wszystkich giełdach</p>
          </td>
      </tr>
      <tr>
          <td>
              <p>Dodatkowe konto użytkownika</p>
          </td>
          <td>
              <p>45,00 zł</p>
          </td>
          <td>
              <p>wskazać ilość w liczbach</p>
          </td>
      </tr>
  </table>
  <p>¹ Użytkownik w każdej chwili może dokonać zmiany Abonamentu na warunkach z Regulaminu.</p>
  <p> ² Opłaty za zmiany w abonamencie będą uwzględnione w najbliższym okresie rozliczeniowy. </p>
  <p>³ Usługodawca zastrzega sobie możliwość dokonania w każdym czasie zmiany stawek poszczególnych opłat. </p>
  
  <p><a id="_Hlk103628083"></a><strong>ZAŁĄCZNIK DO REGULAMINU</strong></p>
  <p><strong>„WARUNKI WINDYKACJI”</strong></p>
  <p><strong>kontenerowy.pl, e-containers.eu, econtainers.ru, e-containers.de, e-containers.pl, 4containers.eu,
          4containers.ru, 4containers.pl, 4containers.de</strong></p>
  <ol>
      <li>Wynagrodzenie Usługodawcy z tytułu świadczenia usług windykacji wynosi od 10% dochodzonej należności netto.
          Kwota wynagrodzenia zostanie powiększona o podatek VAT w wysokości przewidzianej przez obowiązujące w tym
          zakresie przepisy w dniu wystawienia faktury.</li>
      <li>Prowizja przysługuje Użytkownikowi z chwilą uregulowania przez dłużnika danego zobowiązania w całości lub w
          części. Wynagrodzenie będzie należne Usługodawcy również wtedy gdy po dacie przyjęcia zlecenia dłużnik zapłaci
          dochodzoną należność również w wyniku ugody czy innego porozumienia skutkującego zaspokojeniem należności
          Użytkownika, również poprzez otrzymanie świadczenia niepieniężnego; w takim przypadku podstawą do ustalenia
          wysokości wynagrodzenia Usługodawcy będzie rynkowa wartość tego świadczenia netto. </li>
      <li>Użytkownik nie ponosi żadnych dodatkowych opłat związanych ze zleceniem windykacji. W przypadku uiszczenia długu
          w części Użytkownik zobowiązany jest do zapłacenia wynagrodzenia ustalonego wg zasad wskazanych powyżej
          liczonego od uiszczonej części długu.</li>
      <li>Prowizja płatna będzie na rachunek bankowy Usługodawcy w terminie 14 dni od daty otrzymania przez Użytkownika
          faktury VAT. Użytkownik wyraża zgodę na otrzymywanie faktur drogą elektroniczną.</li>
      <li>Wycofanie zlecenia przez Użytkownika wymaga formy pisemnej lub oświadczenia złożonego drogą mailową. Wpłaty
          dokonane przez dłużnika w ciągu 2 miesięcy od daty wycofania zlecenia są traktowane jako wynik działania
          Usługodawcy. Użytkownik zobowiązuje się powiadamiać Usługodawcy o powyższych wpłatach drogą elektroniczną.</li>
      <li>Użytkownik udzieli stałych pełnomocnictw Usługodawcy (lub wskazanej przez niego osobie) do reprezentowania
          Użytkownika jako pełnomocnika w postępowaniu polubownym oraz upoważni Usługodawcę do odbioru należności od
          dłużników Użytkownika.</li>
      <li>W przypadku otrzymania od dłużnika jakichkolwiek wpłat, Usługodawca zobowiązuje się powiadomić o powyższym
          fakcie Użytkownika niezwłocznie, nie później niż w ciągu 2 dni roboczych. Po otrzymaniu takiej informacji
          Usługodawca wystawi fakturę VAT obejmującą należne mu wynagrodzenie. Użytkownik przyjmuje do wiadomości, iż
          informację odnośnie spłaty zadłużenia Usługodawca może pozyskiwać również bezpośrednio od dłużnika.</li>
      <li>Użytkownik jest zobowiązany do bieżącego informowania Usługodawcy o prowadzonych z dłużnikiem rozmowach oraz
          zawieranych ugodach. Usługodawca zobowiązuje się do informowania Użytkownika o przebiegu wykonywanego zlecenia
          oraz przestrzegania tajemnicy przedsiębiorstwa dotyczącej działalności gospodarczej Użytkownika.</li>
      <li>W czasie trwania zlecenia Użytkownik nie może bez zgody i wiedzy Usługodawcy dokonywać jakichkolwiek ustaleń z
          dłużnikiem odnośnie zapłaty długu.</li>
  </ol>
    </div>
)